import { gql } from '__generated__/gql';

export const LIST_HOTEL_GROUPS_QUERY = gql(`
  query ListHotelGroups($spaceId: Int, $searchTerm: String, $skip: Int, $take: Int) {
    listHotelGroups(spaceId: $spaceId, searchTerm: $searchTerm, skip: $skip, take: $take) {
      totalCount
      hotelGroups {
        id
        name
        createdAt
        updatedAt
        hotels {
          id
          name
          refCode
        }
      }
    }
  }
`);

export const VIEW_HOTEL_GROUP_QUERY = gql(`
  query ViewHotelGroup($id: Int!) {
    viewHotelGroup(id: $id) {
      id
      name
      createdAt
      updatedAt
      hotels {
        id
        name
        refCode
        businessCity
        businessCountry
      }
    }
  }
`);

export const CREATE_HOTEL_GROUP_MUTATION = gql(`
  mutation CreateHotelGroup($spaceId: Int, $data: HotelGroupCreateInput!) {
    createHotelGroup(spaceId: $spaceId, data: $data) {
      id
      name
    }
  }
`);

export const UPDATE_HOTEL_GROUP_MUTATION = gql(`
  mutation UpdateHotelGroup($id: Int!, $data: HotelGroupInput!) {
    updateHotelGroup(id: $id, data: $data) {
      id
      name
    }
  }
`);

export const DELETE_HOTEL_GROUP_MUTATION = gql(`
  mutation DeleteHotelGroup($id: Int!) {
    deleteHotelGroup(id: $id)
  }
`);
